import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getCartDetail =   (id, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/cart', // for android use
    headers:   getHeaders(),
  });
};

export const getCartDetailV2 =   (id, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/cart/v2', // for android use
    headers:   getHeaders(),
  });
};

export const getCartDetailOffer =   (id, storeId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/cart-offer', // for android use
    headers:   getHeaders(),
  });
};